import React, { useEffect, useState } from 'react'
import TopNavbar from '../../components/Nav/TopNavbar'
import Footer from '../../components/Sections/Footer/Footer'
import wave from '../../assets/WhatWeDo/wave2.png'
import frame4 from '../../assets/WhatWeDo/frame4.png'
import greenpattern from '../../assets/WhatWeDo/greenpattern.png'
import WeD1 from '../../assets/WhatWeDo/WeD1.png'
import WeD2 from '../../assets/WhatWeDo/WeD2.png'
import WeD3 from '../../assets/WhatWeDo/WeD3.png'
import WeD4 from '../../assets/WhatWeDo/WeD4.png'
import img1 from '../../assets/WhatWeDo/Elements/img1.png'
import img2 from '../../assets/WhatWeDo/Elements/img2.png'
import img3 from '../../assets/WhatWeDo/Elements/img3.png'
import img4 from '../../assets/WhatWeDo/Elements/img4.png'
import img5 from '../../assets/WhatWeDo/Elements/img5.png'
import img6 from '../../assets/WhatWeDo/Elements/img6.png'
import img7 from '../../assets/WhatWeDo/Elements/img7.png'
import img8 from '../../assets/WhatWeDo/Elements/img8.png'
import insta from '../../assets/WhatWeDo/svg/insta.svg'
import x from '../../assets/WhatWeDo/svg/x.svg'
import aboutWave from '../../assets/aboutWave.png'
import about from '../../assets/about.png'
import facebook from '../../assets/WhatWeDo/svg/facebook.svg'
import Rectangle from '../../assets/Rectangle.png'
import Rectangle1 from '../../assets/Rectangle1.jpg'
import Rectangle2 from '../../assets/Rectangle2.jpg'
import Ellipse1 from '../../assets/Ellipse_integrity.png'
import Ellipse2 from '../../assets/Ellipse_inovation.png'
import Ellipse3 from '../../assets/Ellipse_Trust.png'
import Ellipse4 from '../../assets/Ellipse_service.png'
import Ellipse5 from '../../assets/Ellipse_client.png'
import Vision from '../../assets/Vision.png'
import Rectangle4 from '../../assets/Rectangle4.png'
import style from "./style.module.css";
import { useNavigate } from 'react-router-dom';
import serviceBanner from '../../assets/serviceBanner.gif';
import WeD6 from '../../assets/WhatWeDo/WeD6.png'
import rabab from '../../assets/WhatWeDo/rabab.png'
import bg_Dot from '../../assets/WhatWeDo/bg_Dot.png'
import { Subtitles } from '@mui/icons-material'
import homeBannerGif from '../../assets/gifs/headervideo.gif'; // Update this with your actual GIF path
import vector from '../../assets/Vector.png';
import header from '../../assets/WhatWeDo/header.png'
import styled from 'styled-components'
import { Fade } from 'react-reveal'
import Imgpsh from '../../assets/BookaScreen/Imgpsh.jpg';




const PostCard = ({ image, subtitle, authorName, description, authorImage, }) => {
    return (
        <div className="col-12 col-md-3 pl-sm-3 pr-sm-0 mb-4 mt-sm-5 ">
            <div style={{
                backgroundColor: 'white',
                // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                overflow: 'hidden',
                border: "1px solid #EAECF0",
                transition: 'transform 0.3s ease-in-out',
                width: '80%',
            }}
            >
                <div className="w-100">

                    <img alt={authorName} src={image} className="-fluimgid w-100 m-0 " />
                </div>
                <div className='pl-2 ml-1'>
                    <div className='my-1 font15 '
                        style={{
                            fontFamily: "Barlow,sans-serif",
                            color: '#282828',
                            fontWeight: '600',
                        }}
                    > {authorName}</div>
                    <div className=" font12"
                        style={{
                            fontWeight: '400',
                            color: "#3E3E59",
                        }}> {subtitle} </div>
                    <div className="my-1 font12 mb-4"
                        style={{
                            fontWeight: '400',
                            color: "#5F6980",
                        }}> {description} </div>
                    <div className='my-2'
                    >
                        <img className='mr-2'
                            src={facebook}
                            alt="facebook"
                            height="31"
                            width="31"
                        // style={{
                        //     borderRadius: '50%',
                        //     marginRight: '10px',
                        // }}
                        />
                        <img className='mr-2'
                            src={insta}
                            alt="instagram"
                            height="31"
                            width="31"
                        // style={{
                        //     borderRadius: '50%',
                        //     marginRight: '10px',
                        // }}
                        />
                        <img className=''
                            src={x}
                            alt="X"
                            height="31"
                            width="31"
                        // style={{
                        //     borderRadius: '50%',
                        //     marginRight: '10px',
                        // }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
const Tabs = [
    {

        title: 'Our values',
        discription: 'Following are the values that guide our actions, decisions, and relationships ensuring that our company is solution oriented and we consistently deliver value to uphold the highest standards amongst all.',
        img: Rectangle
    },
    {
        title: 'Vision Statement',
        discription: 'We aspire to be the leading HR consultancy across Pakistan and the Middle East, recognized for our ethical, human-centered approach. Our vision is to address the talent challenges that sustainable businesses face for growth and support individuals who want to develop their passionate careers, offering inclusive solutions that drive innovation and success across borders',
        img: Rectangle2
    },
    {
        title: 'Mission Statement',
        discription: 'We strive to deliver inclusive hiring solutions and customized training programs that build a diverse workforce, fostering a diverse talent ecosystem to ensure leadership growth, and organizations success through our personalized services.',
        img: Rectangle2
    },
]

// Define two sets of step labels for each mode
const candidateSteps = [
    {
        icon:Ellipse1,
        title:'Integrity',
    },
    {
        icon:Ellipse2,
        title:'Transparency',
    },
    {
        icon:Ellipse3,
        title:'Empowerment',
    },
    {
        icon:Ellipse4,
        title:'Inclusivity',
    },
    {
        icon:Ellipse5,
        title:'Client-Centricity',
    },
  

];


export default function Aboutus() {
    const navigate = useNavigate();
    const [visibleStep, setVisibleStep] = useState(0);
    const [togglebtn, settogglebtn] = useState(1);
    const [tabsData, settabsData] = useState(Tabs[0])
    const handleButtonClick = () => {
        navigate('/CorporateTrainings');
    };
    const Toglebutton = (index) => {             
        settogglebtn(index);
        setVisibleStep(0); // Reset the visible step to start from the beginning
        if (index != null || index !== undefined) {
            if (index === 1) {
                settabsData(Tabs[index - 1])
            }
            else if (index === 2) {
                settabsData(Tabs[index - 1])
            }
            else if (index === 3) {
                settabsData(Tabs[index - 1])
            }
            else {
                settabsData(Tabs[0])
            }
        }
        else {
            settabsData(Tabs[0])
        }
    };
    useEffect(() => {
        const timer = setInterval(() => {
            setVisibleStep((prev) => {
                if (prev < candidateSteps.length - 1) return prev + 1;
                clearInterval(timer);
                return prev;
            });
        }, 1000);
        return () => clearInterval(timer);
    }, [togglebtn]); // Rerun interval when togglebtn changes
    const { hover_text, image_container, } = style

    const posts = [
        // {
        //     image: img1,
        //     authorName: 'Jocelyn Schleifer',
        //     subtitle: 'Software Engineer',
        //     description: "There are many variations of passages of Lorem Ipsum available"
        // },
        // {
        //     image: img2,
        //     authorName: 'Martin Donin',
        //     subtitle: 'Software Engineer',
        //     description: "There are many variations of passages of Lorem Ipsum available"
        // }, {
        //     image: img3,
        //     authorName: 'Jordyn Septimus',
        //     subtitle: 'Software Engineer',
        //     description: "There are many variations of passages of Lorem Ipsum available"
        // }, {
        //     image: img4,
        //     authorName: 'Leo Arcand',
        //     subtitle: 'Software Engineer',
        //     description: "There are many variations of passages of Lorem Ipsum available"
        // }, 
        {
            image: img5,
            authorName: 'Marilyn Levin',
            subtitle: 'Software Engineer',
            description: "There are many variations of passages of Lorem Ipsum available"
        }, {
            image: img6,
            authorName: 'Lindsey Dokidis',
            subtitle: 'Software Engineer',
            description: "There are many variations of passages of Lorem Ipsum available"
        },
        {
            image: img7,
            authorName: 'Hanna Dias',
            subtitle: 'Software Engineer',
            description: "There are many variations of passages of Lorem Ipsum available"
        },
        {
            image: img8,
            authorName: 'Ryan Gouse',
            subtitle: 'Software Engineer',
            description: "There are many variations of passages of Lorem Ipsum available"
        },

    ];

    return (
        <>


            <TopNavbar />
                <div
                className="container-fluid py-4"
                style={{
                    backgroundImage: `url(${about})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    height: 'auto',
                    width: '100%',
                    backgroundColor: '#D5D0EF',
                    // height:'90vh'
                }}
            >
                <div className="mt-5"></div>
                <div className="row  ">
                    <div
                        className="py-5 container-fluid mb-md-4"
                        style={{
                            position: 'relative',
                            backgroundImage: `url(${serviceBanner})`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            height: 'auto',
                            width: '88.6%',
                            borderRadius: '50px',
                        }}
                    >
                        {/* <img src={serviceBanner} className='container-fluid ' alt="" srcset="" /> */}
                        <div
                        ></div>
                        <div className="invisible d-flex flex-column justify-content-center align-items-center py-5 my-5 text-center" style={{ position: 'relative' }}>
                            <h2 className="font-weight-bold text-white pt-5 mt-5">The Trusted Venue Partner for all your Corporate
                                Events & Conferences</h2>
                            <h6 className="text-white mt-3">No matter if it’s a 10-person strategy meeting or a
                                1000-person conference, we’ve got your back.</h6>
                            <button className="slider_btn" data-toggle="modal" data-target="#bookingModal">Book Now</button>
                        </div>
                        <div className="pb-5 mb-5"></div>
                    </div>
                </div>
            </div>

            <div className="container-fluid py-2 px-0"
                style={{
                    position: 'relative',
                }}
            >
                <div className=" d-none d-md-block" style={{
                    backgroundImage: `url(${bg_Dot})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    padding: 0,
                    position: 'absolute',
                    backgroundColor: "#F3F5F6",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                }}></div>
                <div className="pl-5 py-5">
                    <div className="row  p-3 p-md-5 d-flex justify-content-between ml-3" style={{ color: "#160A54" }}>
                        <div className="px-xl-5  col-md-7 col-sm-12 pb-4 pb-lg-0 text-center text-lg-left">
                        <Fade left> 
                            <h4 className='font30 font-weight-bold'>Meet Our Founder & CEO</h4>
                            <h1 className='font50 font-weight-bold' style={{textAlign:'left',fontSize: "4.5rem"}}>RABAB MATANAT</h1>
                            <p className="mt-3 font21"> Talent Expertz HR Solutions, established in November 2023, is a dynamic, women-led intitative HR solutions provider specializing in high-impact talent’s placements and bridge skill gaps by continuous trainings. As an emerging player in the industry, backed by extensive expertise, we are committed to delivering exceptional talent and human development programs who can help advance the business.
                            </p>
                            </Fade>
                        </div>
                        <Fade right>
                        <div className="col-md-4 col-sm-12">
                            <div className={`${image_container}`}>
                                <img src={Imgpsh} alt="" />
                            </div>
                        </div>
                        </Fade>
                       
                       
                    </div>
                </div>
            </div>






            <div className="container-fluid px-0"
                style={{
                    position: 'relative',
                    backgroundColor: '#D5D0EF',
                    backgroundImage: `url(${aboutWave})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition:" center"
                }}
            >
                <div className=" d-none d-md-block" style={{

                }}></div>
                <div className={togglebtn === 2 ? `pl-5 pt-5` : "pl-5 py-5"}>
                    <div className="row d-flex  mt-5 pt-  ml-3" style={{ color: "#160A54",}}>
                        <div className="  col-md-5 col-sm-12 pb-4 pb-lg-0 text-center text-lg-left">
                            <div className="row mt-sm-0  " >
                                <div className={`d-flex w-100 justify-content-between p-3`} style={{
                                    border: "2px solid rgba(22, 10, 84, 1)",
                                    borderRadius: 15
                                }}>
                                    <button
                                        className={` ${togglebtn === 1 ? 'togglebtnpurple font20' : 'font20'}`}
                                        style={{
                                            fontFamily: "Open Sans,sans-serif",
                                            border: "none", outline: 'none', borderRadius: 15,
                                            paddingTop: "15px",
                                            paddingLeft: "27px",
                                            paddingBottom: "15px",
                                            paddingRight: '26px',
                                            background: "transparent"
                                        }}
                                        onClick={() => Toglebutton(1)}
                                    >
                                        Our Value
                                    </button>
                                    <button
                                        className={` ${togglebtn === 2 ? 'togglebtnpurple font20' : 'font20'}`}
                                        style={{
                                            fontFamily: "Barlow,sans-serif",
                                            border: "none", outline: 'none', borderRadius: 15,
                                            paddingTop: "15px",
                                            paddingLeft: "27px",
                                            paddingBottom: "15px",
                                            paddingRight: '26px',
                                            background: "transparent"
                                        }}
                                        onClick={() => Toglebutton(2)}
                                    >
                                        Our Vision
                                    </button>
                                    <button
                                        className={` ${togglebtn === 3 ? 'togglebtnpurple font20' : 'font20'}`}
                                        style={{
                                            fontFamily: "Barlow,sans-serif",
                                            border: "none", outline: 'none', borderRadius: 15,
                                            //  padding: '10px 25px',
                                            paddingTop: "15px",
                                            paddingLeft: "27px",
                                            paddingBottom: "15px",
                                            paddingRight: '26px',
                                            background: "transparent"
                                        }}
                                        onClick={() => Toglebutton(3)}
                                    >
                                        Our Mission
                                    </button>
                                </div>
                            </div>

                            {/* <h1 className='my-5 py-2 ' style={{ fontSize: "4.5rem" ,textAlign:'left'}} dangerouslySetInnerHTML={{ __html: tabsData?.title}}></h1> */}
                            <p className="mt-3 font20 font-weight-bold"> {tabsData?.discription}   </p>
                           {
                            togglebtn ===1 ? 
                             <StepperWrapper>
                            <StepperContainer>
                                {candidateSteps.map((step, index) => {
                                    return <>
                                        <div className="row align-items-center">
                                            <StepWrapper key={index} visible={index <= visibleStep} className="row align-items-center">
                                                <Step>
                                                    {index < candidateSteps.length - 1 && <StepLine />}
                                                    <img src={step.icon} alt="" />
                                                </Step>


                                                <StepLabel key={index} visible={index <= visibleStep} className='ml-3'>
                                                    {step.title}
                                                </StepLabel>

                                            </StepWrapper>
                                        
                                        </div>
                                    </>
                                })}
                            </StepperContainer>

                            <StepLabelsContainer>
                            </StepLabelsContainer>
                        </StepperWrapper>
                        : togglebtn === 2 ? <div className='d-flex justify-content-end back-image' > <img src={Vision} alt="" width={550} style={{ 
                            maxWidth: "100%",  // Makes it responsive
                            height: "auto" 
                          }}  /> </div>  : togglebtn === 3 ?  <div className='d-flex justify-content-end back-image' > <img src={Rectangle4} alt=""  style={{ 
                            maxWidth: "100%",  // Makes it responsive
                            height: "auto",
                          }}  /> </div>: <StepperWrapper style={{visibility:'hidden'}}>
                        <StepperContainer>
                            {candidateSteps.map((step, index) => {
                                return <>
                                    <div className="row align-items-center">
                                        <StepWrapper key={index} visible={index <= visibleStep} className="row align-items-center">
                                            <Step>
                                                {index < candidateSteps.length - 1 && <StepLine />}
                                                <img src={step.icon} alt="" />
                                            </Step>


                                            <StepLabel key={index} visible={index <= visibleStep} className='ml-3'>
                                                {step.title}
                                            </StepLabel>

                                        </StepWrapper>

                                    </div>
                                </>
                            })}
                        </StepperContainer>

                        <StepLabelsContainer>

                        </StepLabelsContainer>
                    </StepperWrapper>
                     }
                     {/* {togglebtn === 3 && <div className='d-flex justify-content-end back-image' > <img src={Rectangle4} alt=""  style={{ 
                            maxWidth: "100%",  // Makes it responsive
                            height: "auto",
                          }}  /> </div> } */}
                        </div>
                        <div className="col-1"></div>
                        <div className="col-12 col-md-5 p-0 mt-1 position-relative order-1  order-md-2 custom-order-sm-first order-sm-first mb-4 mb-md-0 d-block ">
                            <div className="position-relative ml-2 d-flex align-items-center justify-content-end"
                                style={{ position: 'relative', width: '100%', height: '100%' }}>
                                <div className="position-relative d-flex justify-content-end" style={{ zIndex: 2, height: '90%' }}>
                                    <img
                                        src={tabsData?.img}
                                        alt="Header GIF"                    
                                        className="img-fluid"
                                        style={{
                                            borderRadius: '50px',
                                            boxShadow: "10px 10px  rgb(131, 123, 173)",
                                            marginTop: '0px',
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container-fluid pt-4 "
                style={{
                    backgroundImage: `url(${frame4})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundColor: '#F8F8F4',
                    position: "relative",
                    zIndex: -1,
                }}
            >

                <div className="row d-flex justify-content-center align-items-center  ">
                    <div className="col-md-6 d-flex flex-column justify-content-center align-items-center text-center text-white pl-sm-5">
                        <h5 style={{ fontSize: "18 px", fontFamily: "Barlow,sans-serif", fontWeight: "600", color: "#160A54" }}>OUR TEAM</h5>
                        <h1 className="pb-4 pb-lg-0 pl" id="our_services1" >Meet Our&nbsp;<span id="our_services1" style={{ color: "#04642D", fontFamily: "Barlow,sans-serif", }} >Team at Talent Expertz</span> <h6 className="font18 text-center mt-4" >Let our people provide you The People.
                        </h6> </h1>
                        
                    </div>
        

                </div>
                <div className="container-fluid  p-0 ">
                    <div className="row px-sm-5 mx-sm-5  ">
                        {posts.map((post, index) => (
                            <PostCard key={index} {...post} />
                        ))}

                    </div>
                </div>

            </div>

            <hr className='p-0 m-0'
                style={{
                    borderTop: '1px solid #160A54',
                    width: '100%',
                }}
            />

            <Footer />
        </>
    )
}

const StepperContainer = styled.div`

  margin-top: 20px;

  @media (max-width: 768px) {
    margin-top: 10px; /* Adjust for smaller screens */
  }
`;

const Step = styled.div`
  display: flex;
  flex-direction: row; /* Arrange circle and label side by side */
  align-items: center; /* Align them vertically in the center */
  position: relative;
  margin: 20px 0; /* Space between steps */
`;
const StepNumber = styled.div`
  width: 79px;
  height: 80px;
  background-color: #d5d0ef;
  border: 3px solid #160a54;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: #160a54;
  margin-right: 20px; /* Add space between circle and label */
`;

const StepLine = styled.div`
  width: 3px; /* Thickness for vertical line */
  height: 50px; /* Length of the connecting line */
  background-color: #160a54;
  position: absolute;
  top: 100%; /* Position below the current step */
  left: 50%; /* Center the line */
  transform: translateX(-50%); /* Align with the step */
`;

const StepLabel = styled.div`
  font-size: 16px;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  color: #160a54;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 0.5s ease-in-out;
`;

const StepperWrapper = styled.div`
  width: 100%;
  padding-Left:20px;
  flex-direction: column; /* Ensure labels are below the stepper */
  align-items: center;
  margin-top: 30px;

  @media (max-width: 768px) {
    align-items: flex-start; /* Adjust alignment for smaller screens */
  }
`;

const StepLabelsContainer = styled.div`
  display: flex;
  flex-direction: column; /* Stack labels vertically */
  align-items: center; /* Center align labels */
  margin-top: 10px;

  @media (max-width: 768px) {
    margin-top: 5px;
  }
`;
const StepWrapper = styled.div`
  display: flex;
  align-items: center;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity 0.5s ease-in-out;

  @media (max-width: 768px) {
    flex-direction: column; /* Stack on smaller screens */
    align-items: flex-start;
  }
`;